ACC.track = {
	trackAddToCart: function (productCode, quantity, cartData)
	{
//		window.mediator.publish('trackAddToCart',{
//			productCode: productCode,
//			quantity: quantity,
//			cartData: cartData
//		});
	},
	trackRemoveFromCart: function(ObjToTrack)
	{
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event':'remove_from_cart',
			'ecommerce': {
				'currency' : currentCurrency,
				'value' : ObjToTrack.cartPrice.replace(',','.'),
				'items' : [
					{
						'item_id' : ObjToTrack.productCode,
						'item_name': ObjToTrack.productName,
						'affiliation': ObjToTrack.affiliation,
						'item_brand': "ArcelorMittal",
						'item_category': ObjToTrack.productCat1,
						'item_category2': ObjToTrack.productCat2,
						'product_stock': ObjToTrack.productStock,
						'price': ObjToTrack.productPrice.replace(',','.'),
						'quantity': ObjToTrack.initialCartQuantity
					},
				]
			}
		});
	},


	trackPromoBanner : function() {
		window.dataLayer = window.dataLayer || [];
		var formattedtoday = new Date();
		var datestring = ("0" + formattedtoday.getDate()).slice(-2) + "-" + ("0"+(formattedtoday.getMonth()+1)).slice(-2) + "-" +
			formattedtoday.getFullYear();
		window.dataLayer.push({
			'event':'view_promotion',
			'date': datestring
		});
	},

	trackUpdateCart: function(productCode, initialCartQuantity, newCartQuantity)
	{
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event':'pdp_AjustQuantityEvent',
			'productCode': productCode,
			'initialCartQuantity': initialCartQuantity,
			'newCartQuantity': newCartQuantity
		});

	},

	add_cart: function (productData,productPrice,transferTime , cat1 , cat2 , affiliation ,qty) {
		window.dataLayer = window.dataLayer || [];
		value = qty * Number(ACC.product.productPrice.replace(/\,/g,'.'));
		value = value.toString().replace(',','.');
		formatedValue = value.substring(0,value.indexOf('.')+3);
		window.dataLayer.push({
			'event': 'add_to_cart',
			'ecommerce' : {
				'value' : productData.stock === 'true' ? formatedValue : undefined,
				'currency' : currentCurrency,
				'items': [
					{
						'item_id': productData.productID,
						'item_name': productData.productName,
						'affiliation': affiliation,
						'item_brand': affiliation,
						'item_category': cat1,
						'item_category2': cat2,
						'product_stock': productData.productAvailability,
						'price': productData.stock === 'true' ? ACC.product.productPrice.replace(',','.') : undefined,
						'quantity': qty
					}
				]
			}
		});

	},


	/*	cartValidationEvent: function (cartExpress) {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(GtmCartData);


        },

        },*/

	/*	trackPromoBanner : function() {
            window.dataLayer = window.dataLayer || [];
            var formattedtoday = this.getCurrentDate();
            window.dataLayer.push({
                'event':'view_promotion',
                'date': formattedtoday
            });
        },*/


	storeLocatorIconClickEvent: function () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event':'storeLocatorIconClickEvent',
			'agencyID':POS.agencyID,
			'pageCat':user.pageCat
		});
	},


	errorQuantityEvent: function () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event':'pdp_errorQuantityEvent'
		});
	},


	centralSearchEvent: function (textsearch) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event':'centralSearchEvent',
			'keyword':textsearch
		});
	},
	orderConfirmationBannerClickEvent: function (bannerName) {
		window.dataLayer = window.dataLayer || [];
		var formattedtoday = new Date();
		var datestring = ("0" + formattedtoday.getDate()).slice(-2) + "-" + ("0"+(formattedtoday.getMonth()+1)).slice(-2) + "-" +
			formattedtoday.getFullYear();
		window.dataLayer.push({
			'event':'click_banner',
			'banner_name':bannerName,
			'date': datestring
		});
	},

	orderConfirmationBannerViewEvent: function (bannerName) {
		window.dataLayer = window.dataLayer || [];
		var formattedtoday = new Date();
		var datestring = ("0" + formattedtoday.getDate()).slice(-2) + "-" + ("0"+(formattedtoday.getMonth()+1)).slice(-2) + "-" +
			formattedtoday.getFullYear();
		window.dataLayer.push({
			'event':'view_banner',
			'banner_name ':bannerName,
			'date': datestring
		});
	},

	homeBannerClickEvent: function(bannerName){
		window.dataLayer = window.dataLayer || [];
		var formattedtoday = this.getCurrentDate();
		window.dataLayer.push({
			'event':'click_banner',
			'banner_name':bannerName,
			'date': formattedtoday
		});
	},

	homePageSliderBannerClickEvent: function(bannerName){
    		window.dataLayer = window.dataLayer || [];
    		var formattedtoday = this.getCurrentDate();
    		window.dataLayer.push({
    			'event':'click_banner',
    			'banner_name':bannerName,
    			'date': formattedtoday
    		});
    	},

    homePageSliderBannerViewEvent: function(bannerName){
        		window.dataLayer = window.dataLayer || [];
        		var formattedtoday = new Date();
        		var datestring = ("0" + formattedtoday.getDate()).slice(-2) + "-" + ("0"+(formattedtoday.getMonth()+1)).slice(-2) + "-" +
        			formattedtoday.getFullYear();
        		window.dataLayer.push({
        			'event':'view_banner',
        			'banner_name':bannerName,
        			'date': datestring
        		});
       },

	homeBannerViewEvent: function(bannerName){
		window.dataLayer = window.dataLayer || [];
		var formattedtoday = new Date();
		var datestring = ("0" + formattedtoday.getDate()).slice(-2) + "-" + ("0"+(formattedtoday.getMonth()+1)).slice(-2) + "-" +
			formattedtoday.getFullYear();
		window.dataLayer.push({
			'event':'view_banner',
			'banner_name':bannerName,
			'date': datestring
		});
	},

	accountBannerViewEvent: function(bannerName){
		window.dataLayer = window.dataLayer || [];
		var formattedtoday = new Date();
		var datestring = ("0" + formattedtoday.getDate()).slice(-2) + "-" + ("0"+(formattedtoday.getMonth()+1)).slice(-2) + "-" +
			formattedtoday.getFullYear();
		window.dataLayer.push({
			'event':'view_banner',
			'banner_name':bannerName,
			'date': datestring
		});
	},

	accountBannerClickEvent: function(bannerName){
		window.dataLayer = window.dataLayer || [];
		var formattedtoday = new Date();
		var datestring = ("0" + formattedtoday.getDate()).slice(-2) + "-" + ("0"+(formattedtoday.getMonth()+1)).slice(-2) + "-" +
			formattedtoday.getFullYear();
		window.dataLayer.push({
			'event':'click_banner',
			'banner_name':bannerName,
			'date': datestring
		});
	},

	getCurrentDate:function(){
		var currentDate = new Date();
		var d = currentDate.getDate(); d = d >= 10 ? d : '0'+d;
		var m = currentDate.getMonth() + 1; m = m >= 10 ? m : '0'+m;
		var y = currentDate.getFullYear();
		var formattedtoday = d + '-'+  m + '-' + y;
		return formattedtoday;
	},

	abandonnedCartViewEvent: function (){
		window.dataLayer = window.dataLayer || [];
		var formattedtoday = new Date();
		var datestring = ("0" + formattedtoday.getDate()).slice(-2) + "-" + ("0"+(formattedtoday.getMonth()+1)).slice(-2) + "-" +
			formattedtoday.getFullYear();
		window.dataLayer.push({
			'event':'click_abandoned_cart',
			'date': datestring
		});
	},
	validateAbandonnedCartEvent: function (){
		window.dataLayer = window.dataLayer || [];
		var formattedtoday = new Date();
		var datestring = ("0" + formattedtoday.getDate()).slice(-2) + "-" + ("0"+(formattedtoday.getMonth()+1)).slice(-2) + "-" +
			formattedtoday.getFullYear();
		window.dataLayer.push({
			'event':'abandoned_cart_validation',
			'date': datestring
		});
	},
	contentsquareAPVTracking : function (url){
		window._uxa = window._uxa || [];
		window._uxa.push(['trackPageview', window.location.pathname + '?cs-popin-' + url]);
	},
	trackForms : function (formName , formId){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event':'submit_form',
			'form_name': formName,
			'form_id': formId
		});

	}

};